import log from 'sentry/log'

export const reportUser = async ({
  selectedChannel,
  offendingUser,
  reportCategory,
  description,
}) => {
  let response
  try {
    response = await selectedChannel.reportUser(
      offendingUser,
      reportCategory,
      description,
      (error) => {
        if (error) {
          throw error
        }
      },
    )
  } catch (e) {
    log.message(`Chat: selectedChannel.reportUser error:', ${e}`)
    response = 'failed'
  }

  return response
}
